import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-confirm',
  templateUrl: './dialog-confirm.component.html',
  styleUrls: ['./dialog-confirm.component.sass'],
})
export class DialogConfirmComponent {
  title = '';
  content = 'Você tem certeza?';
  noText = 'Cancelar';
  yesText = 'Sim';

  constructor(
    public dialogRef: MatDialogRef<DialogConfirmComponent>,
    @Inject(MAT_DIALOG_DATA)
    data: {
      title: string;
      content: string;
      noText: string;
      yesText: string;
    }
  ) {
    if (data?.title) this.title = data.title;
    if (data?.content) this.content = data.content;
    if (data?.noText) this.noText = data.noText;
    if (data?.yesText) this.yesText = data.yesText;
  }

  clickNo() {
    this.dialogRef.close(false);
  }

  clickOk() {
    this.dialogRef.close({ result: true });
  }
}
